import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import { ModalController } from '@ionic/angular';
import { asyncScheduler } from 'rxjs';

@Component({
  selector: 'app-lifeless',
  templateUrl: './lifeless.page.html',
  styleUrls: ['./lifeless.page.scss'],
})
export class LifelessPage implements OnInit, AfterViewInit, OnDestroy {

  public isIos = false;
  public heart = false;

  constructor(
    private modalCtrl: ModalController
  ) { }

  ngOnInit() {
    this.isIos = Capacitor.getPlatform() === 'ios';
    asyncScheduler.schedule(() => this.heart = true, 100);
  }

  ngAfterViewInit() {
  }

  ngOnDestroy() {
  }

  public onClose = () => this.modalCtrl.dismiss(true);

}
